module.exports = __webpack_public_path__ + "static/media/delete.fca02832.svg";